const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/artists/$id.shows.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getFindArtistSuspenseQueryOptions } from '@api';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_rootLayout/artists/$id/shows')({
  loader: async ({
    context: {
      queryClient
    },
    params
  }) => {
    queryClient.ensureQueryData(getFindArtistSuspenseQueryOptions(params.id));
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});